module.exports = __webpack_public_path__ + "img/31.3f0ab8ba.jpg";